import React from 'react';
import cn from 'classnames';
import Instructions from './Instructions';
import StakeholderBenefits from './StakeholderBenefits';
import Awards from '../Awards';
import LearnMore from '../LearnMore';
import FooterPattern from '@framework/ui/Pages/Landing/Sections/FooterPattern';
import titlePattern from '../assets/titlePattern.svg';

import baseStyles from '../tenantInvestorSet.module.scss';
import styles from './howItWorks.module.scss';

const HowItWorks = () => (
  <>
    <div className={ cn(baseStyles.intro, styles.intro) }>
      <h1 className={ cn(baseStyles.sectionTitle, baseStyles.title) }>
        How InvestorSet works
      </h1>
      <div className={ baseStyles.titlePattern }>
        <img src={ titlePattern.src } />
      </div>
    </div>
    <div className={ styles.howItWorksContentContainer }>
      <Instructions />
    </div>
    <StakeholderBenefits />
    <Awards className={ styles.awardsWrp } />
    <LearnMore />
    <FooterPattern />
  </>
);

export default HowItWorks;
